<div class="container">
  <div class="row">
    <div class="col-12 col-md-6">
      <app-nivel-academico></app-nivel-academico>
    </div>
    <div class="col-12 col-md-6">
      <app-resumen></app-resumen>
    </div>
  </div>
</div>
